declare global {
  interface Window {
    ipc?: {
      postMessage: (message: string) => void;
    };
  }
}

export function postIpc(payload: Record<string, string>) {
  window.ipc?.postMessage(JSON.stringify(payload));
}
